import { useCallback, useState } from 'react';

export type TInterceptor = () => boolean | void | Promise<boolean | void>;
export type TSetInterceptor = (interceptor: TInterceptor | null) => void;

export const useInterceptor = () => {
	const [interceptor, _setInterceptor] = useState<TInterceptor | null>(null);

	const setInterceptor = useCallback((interceptor: TInterceptor | null) => {
		_setInterceptor(() => interceptor);
	}, []);

	return [interceptor, setInterceptor] as const;
};
